import { Stack, Typography } from '@mui/material';
import { NoInvoiceDetails } from '@vy/ui-design-system';
import { FC } from 'react';

export const QbInvoiceDetailsEmptyState: FC = () => {
  return (
    <Stack
      direction="column"
      sx={{
        gap: "9x",
        alignItems: "center",
        justifyContent: "center",
        height: "271px"
      }}>
      <div style={{ paddingBottom: '12px' }}>
        <NoInvoiceDetails />
      </div>
      <Typography
        sx={{
          lineHeight: "20px",
          fontWeight: 600,
          fontSize: 14
        }}>
        No invoice details available
      </Typography>
      <Typography
        sx={{
          lineHeight: "20px",
          color: "#7E8796",
          fontSize: 14,
          textAlign: "center",
          width: "288px"
        }}>
        We’ll show invoice information here once the QuickBooks sync is complete.
      </Typography>
    </Stack>
  );
};
